import axios from 'axios';
import { environment } from 'src/environment/environment';

export const httpClient = axios.create({
  baseURL: environment.backEnd,
});


httpClient.interceptors.request.use(
  (config) => {
    config.headers['Content-Language'] = localStorage.getItem("i18nextLng") ?? "es";
    return config;
  },
  (error) => Promise.reject(error)
);
